<template>
    <div class="answer-setting-section px-4">
        <SortingList
            v-if="questionType == 'sorting_list'"
            ref="answerSection"
            :question-index="questionIndex"
            :answers="answers"
        />
        <Typing
            v-else-if="questionType == 'typing_question'"
            ref="answerSection"
            :question-index="questionIndex"
            :answer="answers[0]"
        />
        <Scramble
            v-else-if="questionType == 'scramble'"
            ref="answerSection"
            :question-index="questionIndex"
            :answer="answers[0]"
        />
        <NormalAnswers
            v-else
            ref="answerSection"
            :question-index="questionIndex"
            :question-type="questionType"
            :answer-required="answerRequired"
            :answers="answers"
        />
    </div>
</template>

<script>
import SortingList from '@/components/quiz-creator/question-section/answers/SortingList'
import Typing from '@/components/quiz-creator/question-section/answers/Typing'
import Scramble from '@/components/quiz-creator/question-section/answers/Scramble'
import NormalAnswers from '@/components/quiz-creator/question-section/answers/NormalAnswers'

export default {
    components: {
        SortingList,
        Typing,
        Scramble,
        NormalAnswers
    },

    props: {
        questionIndex: {
            type: Number,
            required: true
        },

        questionType: {
            type: String,
            default: 'basic'
        },

        answerRequired: {
            type: String,
            default: 'one'
        },

        answers: {
            type: Array,
            required: true
        }
    },

    methods: {
        async validateAnswerSection() {
            const passed = await this.$refs.answerSection.validateAnswers()

            const payload = {
                section: 'answer',
                questionIndex: this.questionIndex,
                passed
            }

            this.$emit('validate-result', payload)

            return true
        }
    }
}
</script>

<style lang="scss">
.answer-setting-section {
    .answers-required-box {
        column-gap: 0.5rem;
    }

    .answer-check,
    .move-handle {
        top: 50%;
        left: 0.5rem;
        transform: translateY(-50%);
    }

    .answers-section {
        input {
            padding: 0.375rem 4.5rem 0.375rem 2.6rem !important;
        }
    }

    .percent-match-box {
        column-gap: 0.25rem;
        input {
            flex: 1;
            max-width: 120px;
        }
    }
}
</style>